// Note: https://www.npmjs.com/package/html2pdf.js/v/0.9.0#page-breaks

export const PAGE_BREAK_CLASS_NAME = 'html2pdf__page-break';
export const PRINT_CONTAINER_ID = 'print-container';
